import type { LocationQuery } from 'vue-router'

// Define exactly which tracking keys are allowed
const ALLOWED_TRACKING_KEYS = ['uid', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_source']

/**
 * Picks only the marketing-tracking query parameters (`uid`, `utm_*`) out of a Vue Router
 * `LocationQuery`. Comparison is case-insensitive on the key.
 * @param query - The full route query object.
 * @returns A new query object containing only allowed tracking keys.
 * @category Utils
 */
export const getTrackingQueryParams = (query: LocationQuery) =>
  Object.fromEntries(
    Object.entries(query).filter(([key]) =>
      ALLOWED_TRACKING_KEYS.includes(key.toLowerCase())
    )
  )
